import produce from 'immer';

import {
  CREATE_WORKSPACE_OVER_AGENCY_FAILURE,
  CREATE_WORKSPACE_OVER_AGENCY_SUCCESS,
  FETCH_AGENCY_WORKSPACES_FAILURE,
  FETCH_AGENCY_WORKSPACES_SUCCESS,
  FETCH_WORKSPACE_AGENCY_PRODUCTS_FAILURE,
  FETCH_WORKSPACE_AGENCY_PRODUCTS_SUCCESS,
  FETCH_WORKSPACES_LIST_FAILURE,
  FETCH_WORKSPACES_LIST_SUCCESS,
  SET_WORKSPACES,
  UPDATE_WORKSPACE_AGENCY_FAILURE,
  UPDATE_WORKSPACE_AGENCY_SUCCESS,
  UPDATE_WORKSPACE_SUCCESS,
} from '@actions/workspace';

const initialState: IWorkspaceStore = {
  workspaces: null,
  workspaceListResponse: null,
  error: null,
  workspaceAgencyProducts: null,
};

export default (state: IWorkspaceStore = initialState, action: any) =>
  produce(state, (draftState: IWorkspaceStore) => {
    switch (action.type) {
      case FETCH_AGENCY_WORKSPACES_SUCCESS:
      case CREATE_WORKSPACE_OVER_AGENCY_SUCCESS:
      case UPDATE_WORKSPACE_SUCCESS:
      case UPDATE_WORKSPACE_AGENCY_SUCCESS:
        draftState.workspaces = action.response;
        draftState.error = null;

        return;

      case FETCH_WORKSPACES_LIST_SUCCESS:
        draftState.workspaceListResponse = action.response;
        draftState.error = null;

        return;

      case FETCH_WORKSPACE_AGENCY_PRODUCTS_SUCCESS:
        draftState.workspaceAgencyProducts = action.response;

        return;

      case FETCH_AGENCY_WORKSPACES_FAILURE:
      case FETCH_WORKSPACE_AGENCY_PRODUCTS_FAILURE:
      case CREATE_WORKSPACE_OVER_AGENCY_FAILURE:
      case FETCH_WORKSPACES_LIST_FAILURE:
      case UPDATE_WORKSPACE_AGENCY_FAILURE:
        draftState.error = action.error;

        return;

      case SET_WORKSPACES:
        draftState.workspaces = action.workspaces;
    }
  });
